import Vue from 'vue';

// Lower bound of each screen size, in CSS pixels; phone is everything narrower than tablet.
// Mirrors $breakpoints in assets/styles/variables.scss: change both together.
export const BREAKPOINTS = Object.freeze({
  tablet: 600,
  laptop: 1024,
  desktop: 1280,
  wide: 1920,
});

// Width under which the app shell switches to the menu button and drawer. It predates the
// sizes above and stays as is until the shell moves onto them.
export const COMPACT_LAYOUT_BELOW = 1080;

const sizeQueries = Object.keys(BREAKPOINTS).map((size) => ({
  size,
  query: window.matchMedia(`(min-width: ${BREAKPOINTS[size]}px)`),
}));
const compactQuery = window.matchMedia(`(max-width: ${COMPACT_LAYOUT_BELOW - 0.02}px)`);
const hoverQuery = window.matchMedia('(hover: hover)');

const currentSize = () => sizeQueries.reduce((current, { size, query }) => (query.matches ? size : current), 'phone');

// One set of media-query listeners for the whole app: components read these flags instead
// of each listening to every resize, and the flags change only when a threshold is crossed.
export const viewport = Vue.observable({
  size: currentSize(),
  isCompact: compactQuery.matches,
  canHover: hoverQuery.matches,
});

const onChange = (query, listener) => {
  // Safari before 14 only has the older addListener.
  if (query.addEventListener) query.addEventListener('change', listener);
  else query.addListener(listener);
};

sizeQueries.forEach(({ query }) =>
  onChange(query, () => {
    viewport.size = currentSize();
  }),
);
onChange(compactQuery, (event) => {
  viewport.isCompact = event.matches;
});
onChange(hoverQuery, (event) => {
  viewport.canHover = event.matches;
});
